import React, { forwardRef } from 'react';
import { Text, Icon } from 'view/atoms';
import * as S from './Radio.styles';
import { RadioProps } from './Radio.model';

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      label,
      checked,
      icon,
      name,
      value,
      register,
      subLabel,
      onChange,
      disabled,
      ...rest
    },
    ref,
  ) => {
    return (
      <S.RadioLabel htmlFor={`id-${label}`} disabled={disabled}>
        <S.InputWrapper>
          <S.RadioInput
            type='radio'
            id={`id-${label}`}
            value={value ?? label}
            checked={checked}
            name={name}
            ref={ref}
            onChange={onChange}
            disabled={disabled}
            {...register}
            {...rest}
          />
          <S.TextBlock>
            <Text kind='body' color={disabled ? 'gray2' : 'gray1'}>
              {label}
            </Text>
            {icon && <Icon src={icon} />}
          </S.TextBlock>
        </S.InputWrapper>

        {subLabel && (
          <S.SubLabelWrapper>
            <S.StyledSubLabel>{subLabel}</S.StyledSubLabel>
          </S.SubLabelWrapper>
        )}
      </S.RadioLabel>
    );
  },
);
